module.exports = __webpack_public_path__ + "assets/e6297b9afeed5692472309c0fc4894e1.png";